import React, { useCallback, useState } from 'react';

import MainMenu from './MainMenu';
import { filterMenuItems } from 'utils/navigationUtils';

import { getAdminMenuItems, getAdminMenuItemsSaas, HIDDEN_MENU_ITEMS } from '../constants/adminMenuConstants';

const AdminMenu = (props) => {
    const [adminMenuItems] = useState(getAdminMenuItems(props.agencyRouteName));
    const [adminMenuItemsSaas] = useState(getAdminMenuItemsSaas(props.agencyRouteName));
    const filterMenuItemCallback = useCallback(filterMenuItems(adminMenuItemsSaas, HIDDEN_MENU_ITEMS), [])

    return (
        <MainMenu
            menuItems={props.hiddenSections
                ? filterMenuItemCallback
                : adminMenuItems}
        />
    )
};

export default AdminMenu;
